import { HttpLink } from '@apollo/client';
import fetch from 'isomorphic-unfetch';

export const httpLink = new HttpLink({
  uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
  credentials: 'same-origin',
  fetch,
});
